<!-- 汇率查询 -->
<template>
  <div class="interestRateList">
    <sirui-search
      v-if="dictList.length > 10"
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar v-if="menuButtonList && menuButtonList.length > 0">
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        v-if="dictList.length > 10"
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        column-min-width="120"
        :loading="load"
        :auto-resize="true"
        :data="tableData"
        :columns="columnList"
        :edit-rules="rules"
        :max-height="$store.state.app.tableHeight"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="token"
    ></sirui-upload>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { addRules } from './rules.js'; // 校验规则
  import API from '@/api/capitalCenter/moneyDraw';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiUpload from '@/components/SiruiUpload';
  // import COM_API from '@/api/masterData/company.js';
  // import InputNumber from '@/components/form-item/input-number';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'interestRateList',
    components: {
      SiruiSearch,
      SiruiUpload,
      // InputNumber,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList: (state) => state.dict.dictList,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      searchColumns() {
        return [
          {
            // 业务公司
            name: this.$t('interestRate.column.businessCompany'),
            prop: 'businessCompanyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'changeCompany',
            clearable: true,
            filterable: true,
          },
          {
            // 利率类型
            name: this.$t('interestRate.column.interestRateCode'),
            prop: 'interestRateCode',
            type: 'select',
            options: this.interestRateTypeList,
            filterable: true,
          },
        ];
      },
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'businessCompanyCode',
            title: this.$t('interestRate.column.businessCompany'),
            editRender: {
              name: 'ElSelect',
              options: this.companyList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.companyChange },
            },
          },
          {
            field: 'interestRateCode',
            title: this.$t('interestRate.column.interestRateCode'),
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('interestRateType'),
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.interestRateCodeChange },
            },
          },
          {
            field: 'interestRate',
            title: this.$t('interestRate.column.interestRate'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.interestRate}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.interestRate}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'interestRate')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            field: 'interestEffectiveStartDays',
            title: this.$t('interestRate.column.interestEffectiveStartDays'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.interestEffectiveStartDays}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.interestEffectiveStartDays}
                    max={999999999.999999}
                    min={0}
                    precision={0}
                    onInput={(val) => this.chooseTable(val, row, 'interestEffectiveStartDays')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            field: 'interestEffectiveEndDays',
            title: this.$t('interestRate.column.interestEffectiveEndDays'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.interestEffectiveEndDays}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.interestEffectiveEndDays}
                    max={999999999.999999}
                    min={0}
                    precision={0}
                    onInput={(val) => this.chooseTable(val, row, 'interestEffectiveEndDays')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 利率有效期起
            field: 'interestEffectiveStartDate',
            title: this.$t('interestRate.column.interestEffectiveStartDate'),
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            // 利率有效期止
            field: 'interestEffectiveEndDate',
            title: this.$t('interestRate.column.interestEffectiveEndDate'),
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            field: 'isEnabled',
            title: this.$t('interestRate.column.isEnabled'),
            editRender: {
              name: 'ELInput',
            },
            slots: {
              default: ({ row }) => {
                return [<el-checkbox value={row.isEnabled}></el-checkbox>];
              },
              edit: ({ row }) => {
                return [
                  <el-checkbox
                    onChange={(val) => this.chooseTable(val, row, 'isEnabled')}
                    value={row.isEnabled}
                  ></el-checkbox>,
                ];
              },
            },
          },
          {
            field: 'gmtModified',
            title: this.$t('interestRate.column.gmtModified'),
          },
          {
            field: 'lastModifiedBy',
            title: this.$t('interestRate.column.lastModifiedBy'),
          },
        ];
      },
    },
    data() {
      return {
        companyList: [],
        action: API.IMPORT_INTERESTRATE,
        menuButtonList: [], // 按钮
        load: false,
        tableData: [],
        multipleSelection: [],
        query: {
          businessCompanyCode: '',
          interestRateCode: '',
          interestRateCodes: [],
        },
        interestRateTypeList: [],
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
        rules: addRules,
      };
    },
    mounted() {
      this.getInterestRateTypeList();
      this.getData();
      this.getButtonList();
      this.getCompany();
    },
    methods: {
      getInterestRateTypeList() {
        let interestRateTypeList = this.$baseRequest.getDictListMapByType('interestRateType');
        interestRateTypeList = interestRateTypeList.filter(
          (item) => ['009', '010', '011'].indexOf(item.value) == -1
        ); // 过滤掉值不为3,返回新数组
        this.interestRateTypeList = interestRateTypeList;
        this.query.interestRateCodes = this.interestRateTypeList.map((item) => {
          return item.value;
        });
      },
      chooseTable(val, row, prop) {
        row[prop] = val;
      },
      companyChange(val) {
        val.row.businessCompanyName = this.companyList.find(
          (item) => item.value == val.row.businessCompanyCode
        ).label;
      },
      interestRateCodeChange(val) {
        val.row.interestRateName = this.$baseRequest.getDictValueByType(
          'interestRateType',
          val.row.interestRateCode
        );
      },
      async getData() {
        this.load = true;
        const [pageNum, pageSize] = [this.page.pageNum, this.page.pageSize];
        const params = { ...this.query, pageNum, pageSize };
        let res = await this.$axios.post(API.QUERY_INTERESTRATE_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.tableData.map((item) => {
              item.isEnabled = item.isEnabled == '1' ? true : false;
            });
            this.page.total = res.data.data.total;
          }
        }
      },
      //公司代码
      async getCompany() {
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      chooseClick(value) {
        if (value === 'add') {
          this.handleAdd();
        } else if (value === 'edit') {
          this.handleEdit();
        } else if (value === 'save') {
          this.handleSave();
        } else if (value == 'export') {
          this.handleExport();
        } else if (value == 'import') {
          this.$refs.SiruiUpload.dialogUpload = true;
        } else if (value == 'del') {
          this.handleDel();
        }
      },
      // 跳转至新增页面
      handleAdd() {
        let path = {
          path: '/moneyDraw/interestRateAdd',
          name: 'interestRateAdd',
          meta: {
            keepAlive: true,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 编辑
      handleEdit() {
        let selectRecords = this.$refs.table.getCheckboxRecords();
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach((item) => {
            this.$refs.table.setActiveRow(item);
          });
          this.$refs.table.validate(selectRecords).catch((errMap) => errMap); //修改校验
        } else {
          this.$message({
            showClose: true,
            message: this.$t('interestRate.message.select'),
            type: 'error',
          });
        }
      },
      async handleSave() {
        let res = await this.exportChildData();
        if (res) {
          let params = {
            ...res,
          };
          this.saveData(params);
        }
      },
      async saveData(params) {
        this.loading.startLoading();
        let res = await this.$axios.post(API.SAVE_INTERESTRATE, params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.resetBtnClick();
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      searchBtnClick() {
        this.resetBtnClick();
      },
      // 重置
      resetBtnClick() {
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      // 删除/撤销弹框
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected');
        }
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        this.$confirmAction()
          .then(() => {
            this.del(ids);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除/撤销
      del(ids) {
        const params = {
          ids,
        };
        this.$axios.post(API.DELETE_INTERESTRATE, params).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.table.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.table.validate((valid) => {
            if (valid) {
              tableData.map((item) => {
                item.isEnabled = item.isEnabled ? '1' : '0';
              });
              let param = {
                list: tableData,
              };
              resolve(param);
            }
          });
        });
      },
      //导出功能
      handleExport() {
        const selectedList = this.$refs.table.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          // let params = {
          //   ids: JSON.stringify(ids),
          //   access_token: this.token.access_token,
          // };
          window.location.href = `${baseUrl}${API.EXPORT_INTERESTRATE}?${str}access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.query);
          window.location.href = `${baseUrl}${API.EXPORT_INTERESTRATE}?${params}&access_token=${this.token.access_token}`;
        }
      },
      // 提示
      tips(info) {
        this.$message({
          showClose: true,
          message: this.$t(`interestRate.message.${info}`),
          type: 'error',
        });
      },
    },
  };
</script>
